import { Skeleton as MUISkeleton } from '@mui/material';

import CalendarSkeleton from './Calendar/CalendarSkeleton';
import ListSkeleton from './List/ListSkeleton';

type SkeletonType = 'list' | 'calendar';

type Props = {
  type?: SkeletonType;
};

const Skeleton = ({ type }: Props) => {
  if (type === 'list') {
    return <ListSkeleton />;
  }

  if (type === 'calendar') {
    return <CalendarSkeleton />;
  }

  return <MUISkeleton animation="wave" variant="rectangular" width="100%" height="100%" />;
};

export default Skeleton;
